export default "__VITE_ASSET__480c6efd__$_?component__"